import React from 'react';
import { DatePicker, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCurrentView,
  getIsDrawerVisible,
  getIsFilterDrawerPinned,
  getJumpToDate,
} from '../../redux-saga/selectors';
import { scheduleActions } from '../../redux-saga/actions';
import { TimelineView } from '../../types/timeline';
import { ButtonSelectable } from './ButtonSelectable';
import { IDs } from '../../../../../../constants';
import { getCompanySettings } from '../../../../../../redux/selectors';

export const PeriodPicker = () => {
  const dispatch = useDispatch();
  const jumpToDate = useSelector(getJumpToDate);
  const currentView = useSelector(getCurrentView);
  const isDrawerVisible = useSelector(getIsDrawerVisible);
  const isFilterPinned = useSelector(getIsFilterDrawerPinned);
  const companySettings = useSelector(getCompanySettings);

  // TODO: init me
  const loading = false;

  return (
    <>
      <Row style={{ display: 'flex', flexDirection: 'row' }}>
        <div className="ant-btn-group" style={{ marginBottom: '12px', marginRight: '12px' }}>
          <ButtonSelectable
            id={IDs.dateSelectors.daySelector}
            disabled={loading}
            onClick={() => {
              dispatch(scheduleActions.switchToView(TimelineView.Day));
            }}
            selected={currentView === TimelineView.Day}
          >
            Day
          </ButtonSelectable>

          <ButtonSelectable
            id={IDs.dateSelectors.weekSelector}
            disabled={loading}
            onClick={() => {
              dispatch(scheduleActions.switchToView(TimelineView.Week));
            }}
            selected={currentView === TimelineView.Week}
          >
            Week
          </ButtonSelectable>

          <ButtonSelectable
            id={IDs.dateSelectors.monthSelector}
            disabled={loading}
            onClick={() => {
              dispatch(scheduleActions.switchToView(TimelineView.Month));
            }}
            selected={currentView === TimelineView.Month}
          >
            Month
          </ButtonSelectable>
          {!companySettings?.ThreeWeekScheduleCalendarView &&
            !companySettings?.TwoWeekScheduleCalendarView && (
              <>
                <ButtonSelectable
                  id={IDs.dateSelectors.threeMonthSelector}
                  disabled={loading}
                  onClick={() => {
                    dispatch(scheduleActions.switchToView(TimelineView.ThreeMonths));
                  }}
                  selected={currentView === TimelineView.ThreeMonths}
                >
                  3-Month
                </ButtonSelectable>

                <ButtonSelectable
                  id={IDs.dateSelectors.yearSelector}
                  disabled={loading}
                  onClick={() => {
                    dispatch(scheduleActions.switchToView(TimelineView.Year));
                  }}
                  selected={currentView === TimelineView.Year}
                >
                  Year
                </ButtonSelectable>
              </>
            )}

          {companySettings?.TwoWeekScheduleCalendarView && (
            <ButtonSelectable
              id={IDs.dateSelectors.twoWeekSelector}
              disabled={loading}
              onClick={() => {
                dispatch(scheduleActions.switchToView(TimelineView.TwoWeeks));
              }}
              selected={currentView === TimelineView.TwoWeeks}
            >
              2-Week
            </ButtonSelectable>
          )}
          {companySettings?.ThreeWeekScheduleCalendarView && (
            <ButtonSelectable
              id={IDs.dateSelectors.threeWeekSelector}
              disabled={loading}
              onClick={() => {
                dispatch(scheduleActions.switchToView(TimelineView.ThreeWeeks));
              }}
              selected={currentView === TimelineView.ThreeWeeks}
            >
              3-Week
            </ButtonSelectable>
          )}
        </div>

        {!isDrawerVisible && (
          <div>
            <DatePicker
              id={IDs.dateSelectors.jumpToDate}
              placeholder="Jump to date"
              value={jumpToDate}
              onChange={date => {
                dispatch(scheduleActions.jumpToDate(date));
              }}
            />
          </div>
        )}
      </Row>
      {isDrawerVisible && (
        <div>
          <DatePicker
            id={IDs.dateSelectors.jumpToDate}
            placeholder="Jump to date"
            value={jumpToDate}
            onChange={date => {
              dispatch(scheduleActions.jumpToDate(date));
              if (!isFilterPinned) {
                dispatch(scheduleActions.setIsDrawerVisible(false));
              }
            }}
            style={{ width: '100%' }}
          />
        </div>
      )}
    </>
  );
};
